import React from "react";
import { Language } from "../../../utils";
import makeClasses from "./styles";
import { useSelector } from "react-redux";
import clsx from "clsx";

const PlanCard = ({
  name,
  debitPaymentDate,
  creditPaymentDate,
  credit2To6PaymentDate,
}) => {
  const classes = makeClasses();

  const oddClass = (index) =>
    clsx(classes.cardItem, index % 2 !== 0 && classes.cardItemOdd);

  const { languageTexts } = useSelector((state) => ({
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  return (
    <div className={classes.card}>
      <p className={classes.cardName}>{name}</p>
      <p className={classes.cardSubtitle}>{i18n.get("PaymentPlans.CardSubtitle")}</p>
      <div>
        <div className={oddClass(1)}>
          <p>{i18n.get("PaymentPlans.DebitLabel")}</p>
          <p className={classes.cardItemValue}>{debitPaymentDate}</p>
        </div>
        <div className={oddClass(2)}>
          <p>{i18n.get("PaymentPlans.CreditLabel")}</p>
          <p className={classes.cardItemValue}>{creditPaymentDate}</p>
        </div>
        <div className={oddClass(3)}>
          <p>{i18n.get("PaymentPlans.Credit2To6Label")}</p>
          <p className={classes.cardItemValue}>{credit2To6PaymentDate}</p>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
